module.exports = __webpack_public_path__ + "img/author2.png";